export type KudosEntry = {
  id: string;
  name: string;
  initial: string;
  /** CSS color for Avatar bg — use coach tokens like 'var(--c-training)'. */
  avatarBg: string;
  /** First phrase: "sent Great Run", "hit a PR". */
  action: string;
  /** Optional secondary: quote or metric. */
  payload?: string;
  /** "2h", "4h", "yesterday". */
  timeAgo: string;
  /** Optional decorative emoji (team kudos in today-first.jsx shows 🔥 on first row). */
  emoji?: string;
};

export const ramiroTeam: KudosEntry[] = [
  {
    id: 'lida',
    name: 'Lida',
    initial: 'L',
    avatarBg: 'var(--c-training)',
    action: 'sent Great Run',
    payload: '"Good pace today!"',
    timeAgo: '2h',
    emoji: '🔥',
  },
  {
    id: 'marco',
    name: 'Marco',
    initial: 'M',
    avatarBg: 'var(--c-mental)',
    action: 'hit a PR',
    payload: '1600m 5:42',
    timeAgo: '4h',
  },
];

/** Newbie — no team activity yet. */
export const emptyTeam: KudosEntry[] = [];
